import Vue from "vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";
import ToastHub from "@Scripts/Components/Toast/ToastHub.vue";

import InfoRequest from "@Scripts/Components/InfoRequest/InfoRequest.vue";
import InfoRequestDialog from "@Scripts/Components/InfoRequest/InfoRequestDialog.vue";
import InfoRequestCta from "@Scripts/Components/InfoRequest/InfoRequestCta.vue";
import InfoRequestLink from "@Scripts/Components/InfoRequest/InfoRequestLink.vue";
import SupportRequestLink from "@Scripts/Components/InfoRequest/SupportRequestLink.vue";

import ProfessionalDialog from "@Scripts/Components/ProfessionalDialog/ProfessionalDialog.vue";

import CenterList from "@Scripts/Components/CenterList/CenterList.vue";

import NewsletterSubscribe from "@Scripts/Components/Newsletter/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";

import SearchBox from "@Scripts/Components/Search/SearchBox.vue";

import UsedProductFilter from "@Scripts/Components/UsedProduct/UsedProductFilter.vue";

import JobOfferList from "@Scripts/Components/JobOffer/JobOfferList.vue";
import JobOfferSubscribe from "@Scripts/Components/JobOffer/JobOfferSubscribe.vue";

import AddDevice from "@Scripts/Components/MyMectronic/Device/AddDevice.vue";
import ROICalculator from "@Scripts/Components/ROICalculator/ROICalculator.vue";
import AddDeviceLink from "@Scripts/Components/MyMectronic/Device/AddDeviceLink.vue";
import UpdateTagName from "@Scripts/Components/MyMectronic/Device/UpdateTagName.vue";
import UpdateTagNameLink from "@Scripts/Components/MyMectronic/Device/UpdateTagNameLink.vue";
import DeviceRealTimeData from "@Scripts/Components/MyMectronic/Device/DeviceRealTimeData.vue";
import DeviceDocumentActionMenu from "@Scripts/Components/MyMectronic/Device/DeviceDocumentActionMenu.vue";
import ArticleFilter from "@Scripts/Components/MyMectronic/Article/ArticleFilter.vue";
import ArticleFilterSelector from "@Scripts/Components/MyMectronic/Article/ArticleFilterSelector.vue";
import TrainingFilter from "@Scripts/Components/MyMectronic/Training/TrainingFilter.vue";
import TrainingFilterSelector from "@Scripts/Components/MyMectronic/Training/TrainingFilterSelector.vue";
import MarketingFilter from "@Scripts/Components/MyMectronic/Marketing/MarketingFilter.vue";
import MarketingFilterSelector from "@Scripts/Components/MyMectronic/Marketing/MarketingFilterSelector.vue";

import TrainingRegistrationLink from "@Scripts/Components/MyMectronic/TrainingRegistration/TrainingRegistrationLink.vue";
import TrainingUnsubscribeLink from "@Scripts/Components/MyMectronic/TrainingRegistration/TrainingUnsubscribeLink.vue";
import TrainingRegistrationAdd from "@Scripts/Components/MyMectronic/TrainingRegistration/TrainingRegistrationAdd.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";

import AccountLogin from "@Scripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@Scripts/Components/Account/AccountLogout.vue";
import AccountRegister from "@Scripts/Components/Account/AccountRegister.vue";
import AccountEdit from "@Scripts/Components/Account/AccountEdit.vue";
import AccountEmailConfirmSend from "@Scripts/Components/Account/AccountEmailConfirmSend.vue";
import AccountPasswordRemind from "@Scripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@Scripts/Components/Account/AccountPasswordReset.vue";

import AccountExternalRegister from "@Scripts/Components/Account/AccountExternalRegister.vue";

import AccountVisitorEdit from "@Scripts/Components/Account/AccountVisitorEdit.vue";
import AccountProfileEdit from "@Scripts/Components/Account/AccountProfileEdit.vue";

import CartDetail from "@Scripts/Components/Store/Cart/CartDetail.vue";
import CartPreview from "@Scripts/Components/Store/Cart/CartPreview.vue";
import CheckoutProfileEdit from "@Scripts/Components/Store/Checkout/CheckoutProfileEdit.vue";
import CheckoutConfirm from "@Scripts/Components/Store/Checkout/CheckoutConfirm.vue";
import CheckoutSummary from "@Scripts/Components/Store/Checkout/CheckoutSummary.vue";
import ProductDetailAdd from "@Scripts/Components/Store/Product/ProductDetailAdd.vue";
import ShippingAddressList from "@Scripts/Components/Store/ShippingAddress/ShippingAddressList.vue";
import ShippingAddressEdit from "@Scripts/Components/Store/ShippingAddress/ShippingAddressEdit.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-cookietoast", CookieToast);
        Vue.component("app-toasthub", ToastHub)

        Vue.component("app-inforequest", InfoRequest);
        Vue.component("app-inforequestdialog", InfoRequestDialog);
        Vue.component("app-inforequestcta", InfoRequestCta);
        Vue.component("app-inforequestlink", InfoRequestLink);
        Vue.component("app-supportrequestlink", SupportRequestLink);

        Vue.component("app-professionaldialog", ProfessionalDialog);

        Vue.component("app-centerlist", CenterList);

        Vue.component("app-newslettersubscribe", NewsletterSubscribe);
        Vue.component("app-newsletterunsubscribe", NewsletterUnsubscribe);

        Vue.component("app-searchbox", SearchBox);

        Vue.component("app-usedproductfilter", UsedProductFilter);

        Vue.component("app-jobofferlist", JobOfferList);
        Vue.component("app-joboffersubscribe", JobOfferSubscribe);

        Vue.component("app-adddevice", AddDevice);
        Vue.component("app-roicalculator", ROICalculator);
        Vue.component("app-adddevicelink", AddDeviceLink);
        Vue.component("app-updatetagname", UpdateTagName);
        Vue.component("app-updatetagnamelink", UpdateTagNameLink);
        Vue.component("app-devicerealtimedata", DeviceRealTimeData);
        Vue.component("app-devicedocumentactionmenu", DeviceDocumentActionMenu);
        Vue.component("app-articlefilter", ArticleFilter);
        Vue.component("app-articlefilterselector", ArticleFilterSelector);
        Vue.component("app-trainingfilter", TrainingFilter);
        Vue.component("app-trainingfilterselector", TrainingFilterSelector);
        Vue.component("app-marketingfilter", MarketingFilter);
        Vue.component("app-marketingfilterselector", MarketingFilterSelector);

        Vue.component("app-trainingregistrationlink", TrainingRegistrationLink);
        Vue.component("app-trainingunsubscribelink", TrainingUnsubscribeLink);
        Vue.component("app-trainingregistrationadd", TrainingRegistrationAdd);

        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountregister", AccountRegister);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountemailconfirmsend", AccountEmailConfirmSend);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);
        Vue.component("app-accountexternalregister", AccountExternalRegister);

        Vue.component("app-accountvisitoredit", AccountVisitorEdit);
        Vue.component("app-accountprofileedit", AccountProfileEdit);

        Vue.component("app-cartdetail", CartDetail);
        Vue.component("app-cartpreview", CartPreview);
        Vue.component("app-checkoutprofileedit", CheckoutProfileEdit);
        Vue.component("app-checkoutsummary", CheckoutSummary);
        Vue.component("app-checkout-confirm", CheckoutConfirm);
        Vue.component("app-productdetailadd", ProductDetailAdd);
        Vue.component("app-shippingaddresslist", ShippingAddressList);
        Vue.component("app-shippingaddressedit", ShippingAddressEdit);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
    }
}